import {NgModule} from '@angular/core';
import {DragDropUtil} from 'app/util/drag-drop/drag-drop.util';

@NgModule({
    providers: [DragDropUtil],
})
export class UtilModule {}
